import { render, staticRenderFns } from "./gateway-selection.vue?vue&type=template&id=80b83eae&"
import script from "./gateway-selection.vue?vue&type=script&lang=js&"
export * from "./gateway-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports